import React, { Component } from 'react';
import { Button, Table, Divider, Icon } from 'semantic-ui-react';
import axios from 'axios'
import createBrowserHistory from 'history/createBrowserHistory';
import { Link } from 'react-router-dom'
import { serverIp, firebaseAuth, toCurrency, logComponentLoad } from '../../../../config/constants';
import { checkAdminEmail, getPrintValues } from '../algoliaDashboard/AlgoliaMiscUtils';
import * as UiConsts from '../../../../config/UiConstants';

const history = createBrowserHistory({ forceRefresh: true });


class ZapierLogs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            zapierNotifs: [],
            zapierAccountType: "all",
            loading: false
        }
    }

    componentDidMount() {
        console.log("cpx1 ======componentDidMount");

        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            console.log("elx1 +++++++++:removeListener");


            if (user) {
                if (user.email) {
                    console.log("addx290 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult)
                }

            } else {
                console.log("rlx121 user NOT found");
                this.setState({
                    authed: false,
                    // loading: false,
                    user: user,
                    uid: user.uid
                })
            }


        })
    }



    setAdminResult = (returnObject) => {
        // console.log("++++++ addx294 setAdminResult");
        // console.log("addx2941 returnObject:" + JSON.stringify(returnObject, null, 3));

        logComponentLoad(returnObject, "ZapierLogs");

        if (returnObject.algoliaUser
            && returnObject.algoliaUser.perms
            && returnObject.algoliaUser.perms.includes("ZapierLogs")) {
            console.log("perms ok ZapierLogs")

            // CHECK IF TO GET ALL LOGS
            if (returnObject.algoliaUser.perms.includes("viewStockAccountZapierLogs")) {
                console.log("viewStockAccountZapierLogs yes");
                this.getZapierLogs("all", "all");
            } else {
                console.log("printbodaAccount yes");
                this.getZapierLogs("printbodaAccount", "all");

            }
        }
        this.setState({
            algoliaUser: returnObject.algoliaUser,
            //isAdmin: returnObject.isAdmin,
        })
    }

    getStockAccountNotifs = () => {
        console.log(" ======: stockAccountNotifs");
        this.getZapierLogs("stockAccount", "all");
    }

    getCapitalPutBack = () => {
        console.log(" ======: getCapitalPutBack");
        this.getZapierLogs("stockAccount", "capital_put_back");
    }

    getCapital_put_back_need_to_put_back = () => {
        console.log(" ======: capital_put_back_need_to_put_back");
        this.getZapierLogs("stockAccount", "capital_put_back_need_to_put_back");
    }

    capitalDeduction = () => {
        console.log(" ======: capitalDeduction");
        history.push("/dashboard/updateSingleZapierNotif/"); 
    }

    getStockPayments = () => {
        console.log(" ======: getStockPayments");
        this.getZapierLogs("printbodaAccount", "stockPayment");
    }

    getVatPayments = () => {
        console.log(" ======: getVatPayments");
        this.getZapierLogs("printbodaAccount", "vat_payment");
    }


    getAllNotifs = () => {
        console.log(" ======: getAllNotifs");
        this.getZapierLogs("printbodaAccount", "all");
    }

    getNotAckedNotifs = () => {
        console.log(" ======: getNotAckedNotifs");
        this.getZapierLogs("printbodaAccount", "no");
    }

    getZapierLogs = (sentZapierAccountType, acked) => {
        console.log(" ======getZapierLogs");
        console.log(" sentZapierAccountType:" + sentZapierAccountType);
        console.log("acked:" + acked);

        this.setState({ loading: true })

        let tempFromWhere = null;
        if (acked == 'capital_put_back') {
            console.log("acked == 'capital_put_back'");
            tempFromWhere = 'largeProject'
        }

        axios.post(serverIp + 'stockPayment/getZapierNotifs', {
            apiKey: "getLastTransactions",
            zapierAccountType: sentZapierAccountType,
            action: acked,
            fromWhere: tempFromWhere
        })
            .then((response) => {
                this.setState({ loading: false })
                console.log("getZapierNotifs:" + JSON.stringify(response.data, null, 3));

                if (response.data.result) {
                    console.log("true.. setting zapierNotifs");

                    this.setState({
                        zapierNotifs: response.data.zapierNotifs,
                        loading: false
                    });

                } else {
                    console.log("FAILED");
                    alert("FAILED TO get zapierNotifs:");
                }
            })
            .catch((error) => {
                console.log(error);
                this.setState({
                    loading: false
                })
            });
    }

    render() {

        const stockAccountButtons = this.state.algoliaUser
            && this.state.algoliaUser.perms
            && this.state.algoliaUser.perms.includes("viewStockAccountZapierLogs")
            ? <div>
                <Button color='blue' onClick={this.getStockAccountNotifs}>View Stock Account</Button>
                <Button color='yellow' onClick={this.getVatPayments}>Vat Payments</Button>
                <Button color='brown' onClick={this.getStockPayments}>Stock Payments</Button>
                <Button color='teal' onClick={this.getCapitalPutBack}>View Capital Put Back</Button>
                <Button color='brown' onClick = {this.capitalDeduction}> Enter Capital Deduction</Button> 
                <Button color='purple' onClick = {this.getCapital_put_back_need_to_put_back}> NEED TO PUT BACK!!!</Button> 

                
            </div>
            : ''

        const changeView = this.state.zapierNotifs.length > 0
            ? <div>
                <Button color='green' onClick={this.getAllNotifs}>All</Button>
                <Button color='red' onClick={this.getNotAckedNotifs}>Not Confirmed</Button>
                {stockAccountButtons}
            </div>
            : ''

        const AckedCell = (props) => props.notif.acked == 'yes'
            ? <div>
                <Icon color='green' name='checkmark' size='large' />
                {props.notif.acked}
            </div>
            : <Table.Cell>
                <Icon color='red' name='x' size='large' />
                {props.notif.acked}
            </Table.Cell>

        const ProjectCell = (props) => props.notif.largeProject
            ? <div>
                {props.notif.largeProject.idlargeProjects} - {props.notif.largeProject.name}
            </div>
            : <Table.Cell>
                "NONE"
            </Table.Cell>

        const DedDepCell = (props) => props.notif.depOrDed == 'deposit'
            ? <Table.Cell>
                <Icon color='orange' name='add' size='large' />
                {props.notif.depOrDed}
            </Table.Cell>
            : <Table.Cell>
                <Icon color='red' name='minus circle' size='large' />
                {props.notif.depOrDed}
            </Table.Cell>

        const PutBackCellInner = (props) => this.state.algoliaUser
            && this.state.algoliaUser.perms
            && this.state.algoliaUser.perms.includes("viewStockAccountZapierLogs")
            && (props.notif.fromWhere == 'largeProject' || props.notif.fromWhere == 'capital_put_back')
            && props.notif.accountType == 'stockAccount'
            && props.notif.depOrDed == 'deduct'
            && (props.notif.miscAck == 'no' || !props.notif.miscAck)
            ?
            <div>
                <Icon color='red' name='x' size='large' />
                <Link to={'/dashboard/updateSingleZapierNotif/' + props.notif.idzapierNotifs + "/capital_put_back"} >!!! NEED TO put back</Link>
            </div>
            : <div>
                <Icon color='green' name='checkmark' size='large' />
                <Link to={'/dashboard/updateSingleZapierNotif/' + props.notif.idzapierNotifs + "/capital_put_back"} >VIEW</Link>
            </div>

        const PutBackCell = (props) =>
            this.state.algoliaUser
                && this.state.algoliaUser.perms
                && this.state.algoliaUser.perms.includes("viewStockAccountZapierLogs")
                && props.notif.accountType == 'stockAccount'
                && props.notif.depOrDed == 'deduct'
                && props.notif.fromWhere == 'largeProject'
                ? <Table.Cell>
                    <PutBackCellInner notif={props.notif} />
                </Table.Cell>
                : <Table.Cell>
                    'NONE'
                </Table.Cell>

        const StockCellInner = (props) => this.state.algoliaUser
            && this.state.algoliaUser.perms
            && this.state.algoliaUser.perms.includes("payBackStock")
            && (props.notif.fromWhere == 'stockPayment' || props.notif.fromWhere == 'fabric_payment')
            && props.notif.accountType == 'printbodaAccount'
            && (props.notif.miscAck == 'no' || !props.notif.miscAck)
            ?
            <div>
                <Icon color='red' name='x' size='large' />
                <Link to={'/dashboard/updateSingleZapierNotif/' + props.notif.idzapierNotifs + "/stockPayment"} >PAY STOCK</Link>
            </div>
            : <div>
                <Icon color='green' name='checkmark' size='large' />
                <Link to={'/dashboard/updateSingleZapierNotif/' + props.notif.idzapierNotifs + "/stockPayment"} >VIEW</Link>
            </div>

        const StockPutBackCell = (props) =>
            this.state.algoliaUser
                && this.state.algoliaUser.perms
                && this.state.algoliaUser.perms.includes("payBackStock")
                && props.notif.accountType == 'printbodaAccount'
                && (props.notif.fromWhere == 'stockPayment' || props.notif.fromWhere == 'fabric_payment')
                ? <Table.Cell>
                    <StockCellInner notif={props.notif} />
                </Table.Cell>
                : <Table.Cell>
                    'stock NONE'
                </Table.Cell>


        const VatCellInner = (props) => this.state.algoliaUser
            && this.state.algoliaUser.perms
            && this.state.algoliaUser.perms.includes("payBackStock")
            && props.notif.fromWhere == 'vat_payment'
            && props.notif.accountType == 'printbodaAccount'
            && (props.notif.miscAck == 'no' || !props.notif.miscAck)
            ?
            <div>
                <Icon color='red' name='x' size='large' />
                <Link to={'/dashboard/updateSingleZapierNotif/' + props.notif.idzapierNotifs + "/vat_payment"} >PAY VAT</Link>
            </div>
            : <div>
                <Icon color='green' name='checkmark' size='large' />
                <Link to={'/dashboard/updateSingleZapierNotif/' + props.notif.idzapierNotifs + "/vat_payment"} >VIEW VAT</Link>
            </div>

        const VatPutBackCell = (props) =>
            this.state.algoliaUser
                && this.state.algoliaUser.perms
                && this.state.algoliaUser.perms.includes("payBackVat")
                && props.notif.accountType == 'printbodaAccount'
                && props.notif.fromWhere == 'vat_payment'
                ? <Table.Cell>
                    <VatCellInner notif={props.notif} />
                </Table.Cell>
                : <Table.Cell>
                    'vat NONE'
                </Table.Cell>


        // const PutBackCell = (props) => props.notif.miscAck && props.notif.miscAck == 'no'
        //     && this.state.algoliaUser
        //     && this.state.algoliaUser.perms
        //     && this.state.algoliaUser.perms.includes("viewStockAccountZapierLogs")
        //     && !props.notif.accountType == 'stockAccount'
        //     && !props.notif.fromWhere == 'largeProject'
        //     ? <Table.Cell>
        //         {props.notif.miscAck}
        //     </Table.Cell>
        //     : <Table.Cell>
        //         <PutBackCellInner notif={props.notif} />
        //     </Table.Cell>

        const tableRow = this.state.zapierNotifs.length > 0
            ? this.state.zapierNotifs.map((trans) =>
                <Table.Row>
                    <Table.Cell> {trans.idzapierNotifs} </Table.Cell>
                    <Table.Cell> {trans.sentDate} </Table.Cell>
                    <Table.Cell> {toCurrency(trans.regexAmount)} </Table.Cell>
                    <Table.Cell> <AckedCell notif={trans} />  </Table.Cell>
                    <Table.Cell> <DedDepCell notif={trans} /></Table.Cell>
                    <Table.Cell> {trans.fromWhere} </Table.Cell>
                    <Table.Cell><Link to={'/dashboard/updateSingleZapierNotif/' + trans.idzapierNotifs}>EDIT</Link></Table.Cell>
                    <Table.Cell> {trans.accountType} </Table.Cell>
                    <Table.Cell> <ProjectCell notif={trans} />  </Table.Cell>
                    <Table.Cell> {trans.ackedBy} </Table.Cell>
                    <Table.Cell> {trans.reason} </Table.Cell>
                    <PutBackCell notif={trans} />
                    <StockPutBackCell notif={trans} />
                    <VatPutBackCell notif={trans} />
                    <Table.Cell> {(trans.zapierEmailText.substring(0, 115).replace("Dear PRINTBODA LIMITED PRINTBODA LIMITED,", ""))} </Table.Cell>
                </Table.Row>)
            : ''


        return (this.state.loading === true ? <UiConsts.LoadingComponent /> : <div>
            <Divider horizontal>{'RECENT Notifs'}</Divider>
            {changeView}
            <Table celled>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>Id</Table.HeaderCell>
                        <Table.HeaderCell>Date</Table.HeaderCell>
                        <Table.HeaderCell>Amount</Table.HeaderCell>
                        <Table.HeaderCell>Confirmed</Table.HeaderCell>
                        <Table.HeaderCell>Action</Table.HeaderCell>
                        <Table.HeaderCell>FromWhere</Table.HeaderCell>
                        <Table.HeaderCell>Edit</Table.HeaderCell>
                        <Table.HeaderCell>accountType</Table.HeaderCell>
                        <Table.HeaderCell>Project</Table.HeaderCell>
                        <Table.HeaderCell>ackedBy</Table.HeaderCell>
                        <Table.HeaderCell>Reason</Table.HeaderCell>
                        <Table.HeaderCell>Put Back</Table.HeaderCell>
                        <Table.HeaderCell>Stock Pay</Table.HeaderCell>
                        <Table.HeaderCell>Vat Pay</Table.HeaderCell>
                        <Table.HeaderCell> Text </Table.HeaderCell>
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    {tableRow}
                </Table.Body>

            </Table>
        </div>);
    }
}

export default ZapierLogs;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/zapier/ZapierLogs.js